export const COMPANY_REQUESTS_CODES = {
  CR001: 'companyRequestNotExist',
  CR002: 'companyRequestAlreadyProcessed',
};
